import { render, staticRenderFns } from "./PhysicalPurchases.vue?vue&type=template&id=6cd92e5d"
import script from "./PhysicalPurchases.vue?vue&type=script&lang=js"
export * from "./PhysicalPurchases.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports